import { ShipmentsData } from 'models/Shipments';
import httpApi from '../api/httpApi';
import useSWR from 'swr';

const URL = '/api/v1/sales-shipments';

const useShipments = () => {
    const useShipmentsSWR = () => {
        const createData = (data: ShipmentsData): ShipmentsData => {
            return {
                id: data.id,
                number: data.number,
                customerName: data.customerName,
                invoiceDate: data.invoiceDate,
                orderNumber: data.orderNumber,
            };
        };

        const fetch = (query): Promise<ShipmentsData> => {
            return httpApi
                .get<{ shipments: ShipmentsData }>(query)
                .then((res) => {
                    return res.getData().shipments;
                })
                .catch((error) => {
                    throw error;
                });
        };

        const { data, error, isLoading, mutate } = useSWR(URL, fetch, {
            dedupingInterval: 1000 * 60 * 10,
            errorRetryCount: 3,
        });

        const convertData = (data): ShipmentsData[] => {
            return data.map((el) => {
                return createData(el);
            });
        };

        return {
            shipments: data ? convertData(data['sales-shipments']) : [],
            isLoading: isLoading,
            isError: error,
            forceRefresh: mutate,
        };
    };

    return {
        useShipmentsSWR,
    };
};

export default useShipments;
